import { getIotmaxShipmentStep } from './iotmaxStock'

/**
 * 内部工作台概览的数据层。
 *
 * 之所以单独抽出来：概览条上四个数字要打三个接口，写死在页面里没法单测。
 * 这里只做「取数 + 归一」，页面负责渲染，'-' 表示"没取到"而不是 0。
 */

/** 发货流程到 5 才算走完（见 getIotmaxShipmentStepText），小于 5 的都还压着 */
export const SHIPMENT_DONE_STEP = 5

export function countPendingShipments(list) {
	if (!Array.isArray(list)) return 0
	return list.filter(item => getIotmaxShipmentStep(item) < SHIPMENT_DONE_STEP).length
}

export function pickCurrentStockName(list) {
	if (!Array.isArray(list) || list.length === 0) return ''
	const cur = list.find(item => Number(item.is_login) === 1) || list[0]
	if (!cur) return ''
	return cur.stock_name || cur.name || ''
}

/**
 * 这三个列表接口在 count 为 0 时会直接返回裸数组，而不是 {list, count}，
 * 所以这里统一补一层。不补的话「一件都没有」会被读成「取数失败」而显示 '-'。
 */
export function normalizePaged(other) {
	if (Array.isArray(other)) return { list: other, count: other.length }
	if (!other) return { list: [], count: null }
	const list = Array.isArray(other.list) ? other.list : []
	const raw = other.count
	const count = (raw === undefined || raw === null || raw === '') ? null : Number(raw)
	return { list, count }
}

function readTotal(res) {
	if (!res || res.errcode !== 0) return null
	const { list, count } = normalizePaged(res.other)
	if (count !== null && !Number.isNaN(count)) return count
	return list.length
}

/**
 * @param studioApi  接口集合（便于测试注入假实现）
 * @param appId
 * @param opts.withMaterial  false 时跳过物料接口（stock_user_view_power=1 的人看不到物料）
 * @returns {{currentStockName: string, productTotal: number|null,
 *            materialTotal: number|null, pendingShipmentCount: number|null}}
 */
export async function fetchWorkbenchSummary(studioApi, appId, opts = {}) {
	const withMaterial = opts.withMaterial !== false
	const out = {
		currentStockName: '',
		productTotal: null,
		materialTotal: null,
		pendingShipmentCount: null
	}

	// 单个接口出错只让它对应的那格空着，不能整块不渲染：
	// 概览是"顺手看一眼"，不该因为某个接口抽风就变成页面报错。
	const safe = async (fn) => {
		try {
			return await fn()
		} catch (e) {
			return null
		}
	}

	const stockRes = await safe(() => studioApi.Teaching_studio_apiIotmaxStock_listGet({ app_id: appId }))
	if (stockRes && stockRes.errcode === 0) {
		out.currentStockName = pickCurrentStockName(stockRes.other)
	}

	const [productRes, materialRes, shipmentRes] = await Promise.all([
		safe(() => studioApi.Teaching_studio_apiIotmaxProductListGet({
			app_id: appId, is_iotmax: 1, page: 1, each_page: 1
		})),
		withMaterial
			? safe(() => studioApi.Teaching_studio_apiIotmaxMaterialListGet({ app_id: appId, page: 1, each_page: 1 }))
			: Promise.resolve(null),
		safe(() => studioApi.Teaching_studio_apiIotmaxShipmentListGet({ app_id: appId, page: 1, each_page: 20 }))
	])

	out.productTotal = readTotal(productRes)
	if (withMaterial) out.materialTotal = readTotal(materialRes)

	if (shipmentRes && shipmentRes.errcode === 0) {
		const { list } = normalizePaged(shipmentRes.other)
		out.pendingShipmentCount = countPendingShipments(list)
	}

	return out
}
